import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../environments/environment";
import {ParamsBuildHelper} from "../helper/params-build-helper";
import {POSUpload} from "../model/pro-report/POSUpload";
import {Prior} from "../model/pro-report/HeaderDetails";
import {ArticleNews} from "../model/ArticleNews";

@Injectable({
  providedIn: 'root'
})
export class DocumentService {
  constructor(private http: HttpClient) {
  }

  public getPriorDealsDoc(doc_id: string, doc_type: string): Observable<Blob> {
    return this.http.get(environment.apiUrl + '/documents/doc-pdf' + ParamsBuildHelper.buildGetParams({
      'doc_id': doc_id,
      'doc_type': doc_type
    }), {responseType: 'blob'});
  }

  public getMgnDoc(story_id: string): Observable<ArticleNews> {
    return this.http.get<ArticleNews>(environment.apiUrl + '/documents/doc-mgn' + ParamsBuildHelper.buildGetParams({
      'story_id': story_id
    }));
  }

  public uploadPOSDocument(posUploadDetails: POSUpload, file: File): Observable<Prior> {
    const formData = new FormData();
    formData.append('posUploadDetails', JSON.stringify(posUploadDetails));
    formData.append('file', file);
    return this.http.post<Prior>(environment.apiUrl + '/pos-document', formData
    );
  }

  public editPOSDocument(posUploadDetails: POSUpload, file: File): Observable<Prior> {
    const formData = new FormData();
    formData.append('posUploadDetails', JSON.stringify(posUploadDetails));
    if (file) formData.append('file', file);
    return this.http.put<Prior>(environment.apiUrl + '/pos-document', formData
    );
  }

  public deletePOSDocument(docLink: string): Observable<any> {
    return this.http.delete<any>(environment.apiUrl + '/pos-document/' + docLink);
  }


}
